import { createFileRoute } from "@tanstack/react-router";
import Glossary from "@/pages/site/Glossary";

export const Route = createFileRoute("/resources/glossary")({
  component: () => <Glossary />,
});
